import { Controller } from "@hotwired/stimulus"

const selectedClasses = ["border-gray-200", "bg-white", "text-gray-900", "shadow-sm"]
const unselectedClasses = ["border", "border-transparent", "text-gray-700", "ml-0.5"]

// Toggles the pricing card between monthly and yearly. Price label, button styling, and the
// checkout link's billing_interval are updated together so the shown interval and the interval the
// checkout actually starts can never disagree. Targets are scoped to the controller element and
// guarded, so this is a no-op (not a crash) when signed out and the checkout link is absent.
export default class extends Controller {
    static targets = ["price", "checkout", "monthlyButton", "yearlyButton"]

    click(event) {
        const yearly = event.params.interval === "yearly"

        this.priceTarget.innerHTML = yearly
            ? '$45 <span class="ml-1 text-2xl font-medium tracking-normal text-gray-500">/year</span>'
            : '$5 <span class="ml-1 text-2xl font-medium tracking-normal text-gray-500">/mo</span>'

        if (this.hasMonthlyButtonTarget && this.hasYearlyButtonTarget) {
            this.select(yearly ? this.yearlyButtonTarget : this.monthlyButtonTarget,
                        yearly ? this.monthlyButtonTarget : this.yearlyButtonTarget)
        }

        this.checkoutTargets.forEach((link) => {
            const url = new URL(link.href, window.location.origin)
            url.searchParams.set("billing_interval", yearly ? "yearly" : "monthly")
            link.setAttribute("href", url.pathname + url.search)
        })
    }

    select(on, off) {
        on.classList.remove(...unselectedClasses)
        on.classList.add(...selectedClasses)
        off.classList.remove(...selectedClasses)
        off.classList.add(...unselectedClasses)
    }
}
